/* eslint-disable @typescript-eslint/no-explicit-any */
import { accountEntityName } from '../../../../backend/features/accounts/shared';
import { getAccountsManageFilter, getAccountsViewFilterNew } from '../../../../backend/features/permissions/shared';
import { useUserState } from '../../../../ui/hooks';
import { mapDynamicFilters } from '@juvare/platform-sdk-react/ui/features/dynamic-columns';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
export function useAccountList(request, useResolvedAccountFilter, advancedSearchItems, location, dynamicColumnData, storageClientFilter, showAllAccounts, showAccountsIManage) {
    var _a, _b;
    const userState = useUserState();
    const resolvedFilter = useResolvedAccountFilter({ advancedSearchItems, filterData: request.filterData, dynamicColumnData });
    let filter = (_a = resolvedFilter.data) !== null && _a !== void 0 ? _a : [];
    const dynamicFilters = mapDynamicFilters(request.filterData, dynamicColumnData);
    if (dynamicFilters.length > 0) {
        filter.push(...dynamicFilters);
    }
    filter = applyFilterDataAsMetadata(filter, request.filterData);
    if (storageClientFilter) {
        filter.push(...storageClientFilter);
    }
    const accountsFilter = showAccountsIManage ? getAccountsManageFilter(userState) : getAccountsViewFilterNew(userState, showAllAccounts);
    const storageRequest = resolvedFilter.data
        ? {
            filter: [...accountsFilter, ...filter],
            orderBy: request.sortColumnKey
                ? [{ column: request.sortColumnKey, desc: request.sortColumnDesc }]
                : undefined,
            offset: request.offset,
            limit: request.limit,
        }
        : undefined;
    const storageResponse = useStorageList(accountEntityName, storageRequest);
    return Object.assign(Object.assign({}, storageResponse), { isLoading: resolvedFilter.isLoading || storageResponse.isLoading, error: (_b = resolvedFilter.error) !== null && _b !== void 0 ? _b : storageResponse.error, data: storageResponse.data
            ? {
                rows: storageResponse.data.rows,
                filteredRowCount: storageResponse.data.total,
            }
            : undefined, reload: storageResponse.mutate, customBackendResponseData: {
            initialAccountFilterData: createInitialAccountFilterDataBasedOnLocation(request.filterData, location),
            storageClientRequest: storageRequest ? { filter: filter, orderBy: storageRequest.orderBy } : undefined,
        } });
}
/**
 * This function ensures that filter data is applied as metadata within first storageFilter element.
 * This could happen if product has overrideUseAccountFilter implemented, but no ContactManagement filters were set within filterData.
 * @param storageFilter
 * @param filterData
 */
function applyFilterDataAsMetadata(storageFilter, filterData) {
    if (storageFilter.length && !storageFilter[0].metadata) {
        storageFilter[0].metadata = { ui: filterData };
    }
    return storageFilter;
}
function createInitialAccountFilterDataBasedOnLocation(filterData, location) {
    if ((location === null || location === void 0 ? void 0 : location.name) === 'org-members') {
        return Object.assign(Object.assign({}, filterData), { orgAssociation: [location.organizationId] });
    }
    else if ((location === null || location === void 0 ? void 0 : location.name) === 'group-members') {
        return Object.assign(Object.assign({}, filterData), { groupMembership: [location.groupId] });
    }
    else {
        return filterData;
    }
}
